export default __webpack_public_path__ + "a8c15f1a35c3617b571918ec7ba10a18.svg";